module.exports = __webpack_public_path__ + "glyphicons-filetypes-regular.97f37fd195a856c58969.eot";


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/css/fonts/glyphicons.filetypes.pro/glyphicons-filetypes-regular.eot
// module id = ../../../../../src/assets/css/fonts/glyphicons.filetypes.pro/glyphicons-filetypes-regular.eot
// module chunks = 2